import { atom } from "jotai"

export const isEditTextAtom = atom("")
